
/**
 * Waits until the page is loaded then calls the callback
 * @param {function} callback 
 */

window.addEventListener('DOMContentLoaded', () => {
    window.onload = () => {
        window.requestAnimationFrame(() => {
            window.dispatchEvent(new Event('frame-ready'))
        })
    }
})